import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import CheckIcon from '@material-ui/icons/Check';
import TableRow from '@material-ui/core/TableRow';
import Utils from '../../Utils';
import ProceduresManualContext from './ProceduresManualContext';
import ProceduresManualTableHeader from './ProceduresManualTableHeader';
import ProceduresManualTableItem from './ProceduresManualTableItem';
import styled from 'styled-components';


const columns = [
  { id: 'sdn', label: 'SDN', minWidth: 200 },
  { id: 'title', label: 'Title', minWidth: 100 },
  {
    id: 'categoryName',
    label: 'Category',
    minWidth: 60,
    maxWidth: 60,
    align: 'right',
    format: value => value ? value : "-",
  },
  {
    id: 'rev',
    label: 'Rev',
    minWidth: 80,
    align: 'right',
    format: value => value ? value : "-",

  },
  {
    id: 'effectiveDate',
    label: 'Effective Date',
    minWidth: 80,
    align: 'right',
    format: value => Utils.formatDate(value),
  },
  {
    id: 'status',
    label: 'Status',
    minWidth: 80,
    align: 'right',
  },
];


const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  tableWrapper: {
  },
});

export default function ProceduresManualTable({ procedures, useTableWrapperStyles = true }) {
  const classes = useStyles();

  const inProgressProcedures = procedures.filter((procedure) => {
    return procedure.status == 'In Progress'
  })

  const approvedProcedures = procedures.filter((procedure) => {
    return procedure.status == 'Approved'
  })

  const publishedProcedures = procedures.filter((procedure) => {
    return procedure.status == 'Published'
  })

  const cancelledProcedures = procedures.filter((procedure) => {
    return procedure.status == 'Cancelled'
  })

  const GroupHeader = styled.div`
    background-color: #ccdce3;
    padding: 16px;
    display: flex;
    align-items: center;
  `;

  const GroupTitle = styled.div`
    margin-right: 30px;
    font-size: 16px;
    font-weight: 500;
`;

  const GroupDescription = styled.div`
    font-weight: 200;
    font-size: 13px;
`;

  return (
    <div className={classes.root}>
      <div className={useTableWrapperStyles ? classes.tableWrapper : null}>
        {!!inProgressProcedures.length &&
          <>
            <GroupHeader>
              <GroupTitle>In Progress</GroupTitle>
              <GroupDescription>These procedures are currently in the workflow and approvals remain to be completed.</GroupDescription>
            </GroupHeader>

            <Table>
              < ProceduresManualTableHeader />
              <TableBody>
                {inProgressProcedures.map(procedure => <ProceduresManualTableItem procedure={procedure} />)}
              </TableBody>
            </Table>
          </>
        }
        {!!approvedProcedures.length &&
          <>
            <GroupHeader>
              <GroupTitle>Approved</GroupTitle>
              <GroupDescription>These procedure have completed the workflow and will be included in next procedure manual revision published. Any procedures with comply as-is status of "N/A" or "No" will remain in "Approved" state and will not be "Published" in the manual.</GroupDescription>
            </GroupHeader>
            <Table>
              < ProceduresManualTableHeader />
              <TableBody>
                {approvedProcedures.map(procedure => <ProceduresManualTableItem procedure={procedure} />)}
              </TableBody>
            </Table>
          </>
        }
        {!!publishedProcedures.length &&
          <>
            <GroupHeader>
              <GroupTitle>Published</GroupTitle>
              <GroupDescription>These procedure are included in the latest revision of the procedure manual.</GroupDescription>
            </GroupHeader>
            <Table>
              < ProceduresManualTableHeader />
              <TableBody>
                {publishedProcedures.map(procedure => <ProceduresManualTableItem procedure={procedure} />)}
              </TableBody>
            </Table>
          </>
        }
        {!!cancelledProcedures.length &&
          <>
            <GroupHeader>
              <GroupTitle>Cancelled </GroupTitle>
              <GroupDescription>These procedure are withdrawn and will not complete the workflow.</GroupDescription>
            </GroupHeader>
            <Table>
              < ProceduresManualTableHeader />
              <TableBody>
                {cancelledProcedures.map(procedure => <ProceduresManualTableItem procedure={procedure} />)}
              </TableBody>
            </Table>
          </>
        }

      </div>

    </div >
  );
}